import $http from '../../service/ajax';
import { getUrlParam } from '../../js/utils';

export function getTypeList() {
  return $http.post(
    '/FrankManager/geoProperty/getList.do',
    {
      ver: '1.0',
      data: {
        type: 5
      }
    }
  );
}

export function getSerial(params) {
  return $http.post(
    '/FrankManager/geom/getGeoByParkingnoOrSerial.do',
    {
      ver: '1.0',
      data: params
    }
  );
}

export function submitSerialData(params) {
  return $http.post(
    `/FrankManager/geoActivate/saveOperate?UID=${getUrlParam('UID')}`,
    {
      ver: '1.0',
      data: params
    }
  );
}
